// src/components/WorldClock.jsx
// Live world clock showing local time + NYC + London + Tokyo.
// Props:
//   compact (bool) — smaller, no-seconds mode for use in Header
import { useState, useEffect } from "react";

const ZONES = [
  { key: "local",            label: "YOUR TIME" },
  { key: "America/New_York", label: "NEW YORK"  },
  { key: "Europe/London",    label: "LONDON"    },
  { key: "Asia/Tokyo",       label: "TOKYO"     },
];

function formatTime(tz, showSeconds) {
  try {
    return new Intl.DateTimeFormat("en-GB", {
      timeZone:    tz === "local" ? undefined : tz,
      hour:        "2-digit",
      minute:      "2-digit",
      ...(showSeconds ? { second: "2-digit" } : {}),
      hour12:      false,
    }).format(new Date());
  } catch {
    return "--:--";
  }
}

export default function WorldClock({ compact = false }) {
  const [tick, setTick] = useState(0);

  useEffect(() => {
    const id = setInterval(() => setTick(t => t + 1), 1000);
    return () => clearInterval(id);
  }, []);

  if (compact) {
    // Inline horizontal strip for Header
    return (
      <div style={{
        display:    "flex",
        alignItems: "center",
        gap:        0,
        flexShrink: 0,
        fontFamily: "'IBM Plex Mono', 'Courier New', monospace",
      }}>
        {ZONES.map((z, i) => (
          <div key={z.key} style={{
            display:       "flex",
            flexDirection: "column",
            alignItems:    "center",
            padding:       "0 12px",
            borderRight:   i < ZONES.length - 1 ? "1px solid #1c2333" : "none",
          }}>
            <span style={{
              fontSize:      9,
              letterSpacing: "0.08em",
              color:         "#4a5568",
              marginBottom:  1,
              whiteSpace:    "nowrap",
            }}>
              {z.label}
            </span>
            <span style={{
              fontSize:      11,
              fontWeight:    600,
              letterSpacing: "0.05em",
              color:         "#8b949e",
              whiteSpace:    "nowrap",
              fontVariantNumeric: "tabular-nums",
            }}>
              {formatTime(z.key, false)}
            </span>
          </div>
        ))}
      </div>
    );
  }

  // Full mode — for use in HomePage hero
  return (
    <div style={{
      display:      "inline-flex",
      alignItems:   "stretch",
      background:   "#080c12",
      border:       "1px solid #1c2333",
      borderRadius: 6,
      overflow:     "hidden",
      fontFamily:   "'IBM Plex Mono', 'Courier New', monospace",
    }}>
      {ZONES.map((z, i) => (
        <div key={z.key} style={{
          display:       "flex",
          flexDirection: "column",
          alignItems:    "center",
          justifyContent:"center",
          padding:       "12px 22px",
          borderRight:   i < ZONES.length - 1 ? "1px solid #1c2333" : "none",
          minWidth:      110,
        }}>
          <span style={{
            fontSize:      9,
            letterSpacing: "0.12em",
            color:         "#4a5568",
            marginBottom:  6,
            textTransform: "uppercase",
          }}>
            {z.label}
          </span>
          <span style={{
            fontSize:           20,
            fontWeight:         700,
            letterSpacing:      "0.04em",
            color:              z.key === "local" ? "#3ddc84" : "#c9d1d9",
            fontVariantNumeric: "tabular-nums",
          }}>
            {formatTime(z.key, true)}
          </span>
        </div>
      ))}
    </div>
  );
}
